// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__2j8sz","tab":"ProcedureTabs_tab__1fHjW"};